var _g, _rect, _g2, _path, _path2, _path3, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendConsentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 101,
    viewBox: "0 0 102 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_56_704)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.0144,
    y: 24.9924,
    width: 92.4722,
    height: 62.4812,
    rx: 9.99699,
    fill: "#C7CDD3"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.0112,
    width: 72.4782,
    height: 81.2255,
    rx: 6.24812,
    fill: "#F7F8FA"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dii_56_704)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.0144 37.4886L43.4968 59.9115C46.4631 61.515 50.0379 61.515 53.0042 59.9115L94.4866 37.4886V77.4766C94.4866 82.9978 90.0108 87.4736 84.4896 87.4736H12.0114C6.49021 87.4736 2.0144 82.9978 2.0144 77.4766V37.4886Z",
    fill: "#C7CDD3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.7557 16.9188C30.7557 15.1664 32.1763 13.7458 33.9287 13.7458H60.8988C62.6512 13.7458 64.0718 15.1664 64.0718 16.9188C64.0718 18.6712 62.6512 20.0918 60.8988 20.0918H33.9287C32.1763 20.0918 30.7557 18.6712 30.7557 16.9188Z",
    fill: "#E4E7EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7557 41.9112C30.7557 40.1589 32.1763 38.7383 33.9287 38.7383H60.8988C62.6512 38.7383 64.0718 40.1589 64.0718 41.9112C64.0718 43.6636 62.6512 45.0842 60.8988 45.0842H33.9287C32.1763 45.0842 30.7557 43.6636 30.7557 41.9112Z",
    fill: "#E4E7EC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7572 29.6103C25.7572 27.858 27.1778 26.4374 28.9302 26.4374H65.4192C67.1716 26.4374 68.5921 27.858 68.5921 29.6103C68.5921 31.3627 67.1716 32.7833 65.4192 32.7833H28.9302C27.1778 32.7833 25.7572 31.3627 25.7572 29.6103Z",
    fill: "#E4E7EC"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ii_56_704)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.383 86.0503C102.52 84.2637 102.52 80.9791 100.383 79.1925L84.641 66.0298C81.7312 63.5967 77.3043 65.6656 77.3043 69.4586V73.7278H60.2179C57.7494 73.7278 55.7483 75.729 55.7483 78.1975V86.753C55.7483 89.2215 57.7494 91.2226 60.2179 91.2226H77.3043V95.7842C77.3043 99.5772 81.7312 101.646 84.641 99.213L100.383 86.0503Z",
    fill: "#4FA3F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_56_704",
    x: -0.484843,
    y: 22.4932,
    width: 96.221,
    height: 66.2301,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2.49925,
    dy: -2.49925
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.87444
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_56_704"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.24962,
    dy: 1.24962
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.24962
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_56_704",
    result: "effect2_innerShadow_56_704"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dii_56_704",
    x: -0.484843,
    y: 34.5728,
    width: 96.6376,
    height: 54.1504,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.24962
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.833091
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0554124 0 0 0 0 0.0657903 0 0 0 0 0.0784743 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_56_704"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_56_704",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2.49925,
    dy: -2.49925
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.87168
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_56_704"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.24962,
    dy: 1.24962
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.24962
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_56_704",
    result: "effect3_innerShadow_56_704"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_56_704",
    x: 53.249,
    y: 61.2316,
    width: 53.7348,
    height: 42.7796,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.9985,
    dy: 3.74887
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.49925
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_56_704"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2.49925,
    dy: -3.74887
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.87444
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_56_704",
    result: "effect2_innerShadow_56_704"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendConsentIcon);
export default __webpack_public_path__ + "static/media/send-consent-icon.0ec3c01070edbaf2f8ee84c15dcb4517.svg";
export { ForwardRef as ReactComponent };